
import mixins from 'vue-typed-mixins'
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import DocumentUploadArea from "@/components/DocumentUploadArea.vue";
import { ApiService } from '@/services/ApiService';
import { error } from '@/services/LoggerService';
export default mixins(SnackbarNotifierMixin).extend({
  name: 'PYBUserUpload',
  components: {SnackbarNotifier,DocumentUploadArea},
  data: () => ({
    uploadInfo: {},
    loading: false,
    retrieveError: false
  }),
  methods: {
    async retrieveUploadDetail(id: string){
      try {
        this.loading = true;
        let result = await ApiService.Instance.pybUserUploadDetail(id);
        if(result && result.instruction) this.uploadInfo = result;
        this.loading = false;
      } 
      catch (err) {
        this.showNotifier({
          message: 'Retrieval Failure',
          snackbarType: "error",
        });
        this.retrieveError = true;
        this.loading = false;
        error(err);
        throw new Error('Failed Retrieve Upload Detail');
      }
    }
  },
  async mounted(){
    let id = this.$route.params.id as string;
    if(!id) id = window.sessionStorage.getItem('id')!;
    await this.retrieveUploadDetail(id);
  }
})
